import React, {Component} from "react";
import "./Projects.css";

import colors from "colours";

export default class ProjectsNew extends Component
{
	render()
	{
		return (
			<div className="projects">
				<div className="project">
					<div className="title">
						PiperCode
					</div>	

					test
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Home/ProjectsNew/ProjectsNew.js